import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'sankhya-file',
    templateUrl: './sankhya-file.component.html',
    styleUrls: ['./sankhya-file.component.scss'],
    standalone: false
})
export class SankhyaFileComponent implements OnInit {

  constructor() { }

  @Input() step1:FormGroup<any>;
  @Input() step2:FormGroup<any>;
  @Input() queryForm:FormGroup<any>
  queryData = null;
  ngOnInit(): void {
  }

  set query(value){
    this.queryData = value;
  }

  get query(){
    return this.queryData; //this.queryForm.get('EXPRESSION').value;
  }

  onQueryChange(evento){
    this.queryForm.get("EXPRESSION").setValue(evento);
  }


}
